import { CommonModule, DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldDefaultOptions, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { AuditComponent } from './components/audit/audit.component';
import { SafePipe } from './pipes/safe.pipe';
import { SecondMenuComponent } from './components/second-menu/second-menu.component';
import { EllipseLinkComponent } from './components/ellipse-link/ellipse-link.component';
import { WarningMessageComponent } from './components/warning-message/warning-message.component';
import { WarningNoteComponent } from './components/warning-note/warning-note.component';
import { EditLabelComponent } from './components/edit-label/edit-label.component';
import { IconCircleComponent } from './components/icon-circle/icon-circle.component';
import { LetterAvatarComponent } from './components/letter-avatar/letter-avatar.component';
import { StatusLabelComponent } from './components/status-label/status-label.component';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { FileDnDDirective } from './directives/file-dnd.directive';
import { ChipComponent } from './components/chip/chip.component';
import { PageSearchBarComponent } from './components/page-search-bar/page-search-bar.component';
import { PageEditTitleComponent } from './components/page-edit-title/page-edit-title.component';
import { DropZoneComponent } from './components/drop-zone/drop-zone.component';
import { PageEmptySearchResultComponent } from './components/page-empty-search-result/page-empty-search-result.component';
import { PageDisabledFeatureComponent } from './components/page-disabled-feature/page-disabled-feature.component';
import { PageDialogComponent } from './components/page-dialog/page-dialog.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { RouterModule } from '@angular/router';
import { QuillModule } from 'ngx-quill';
import { VendorModule } from 'projects/vendors/src/public-api';
import { CatalogDetailDialogComponent } from './components/catalog-detail-dialog/catalog-detail-dialog.component';
import { CatalogDetailProcedureTreeComponent } from './components/catalog-detail-dialog/catalog-detail-procedure-tree/catalog-detail-procedure-tree.component';
import { CatalogRequestAccessDialogComponent } from './components/catalog-request-access-dialog/catalog-request-access-dialog.component';
import { CopyClipboardComponent } from './components/copy-clipboard/copy-clipboard.component';
import { DocumentLinkComponent } from './components/document-link/document-link.component';
import { EditLabelAdvComponent } from './components/edit-label-adv/edit-label-adv.component';
import { EditSelectLabelComponent } from './components/edit-select-label/edit-select-label.component';
import { EllipseComponent } from './components/ellipse/ellipse.component';
import { ExpandableInfoOverlayComponent } from './components/expandable-info/expandable-info-overlay/expandable-info-overlay.component';
import { ExpandableInfoComponent } from './components/expandable-info/expandable-info.component';
import { FilterListComponent } from './components/filter-list/filter-list.component';
import { GalleryComponent } from './components/gallery/gallery.component';
import { HelpLabelComponent } from './components/help-label/help-label.component';
import { HelpSidenavComponent } from './components/help-sidenav/help-sidenav.component';
import { IconSquareComponent } from './components/icon-square/icon-square.component';
import { AddLinkComponent } from './components/mat-quill/add-link/add-link.component';
import { MatQuill } from './components/mat-quill/mat-quill';
import { NestedListsComponent } from './components/nested-lists/nested-lists.component';
import { PageScrollContentComponent } from './components/page-scroll-content/page-scroll-content.component';
import { PageWithTwoSidenavComponent } from './components/page-with-two-sidenav/page-with-two-sidenav.component';
import { SearchInputAdvComponent } from './components/search-input-adv/search-input-adv.component';
import { SearchInputCompactComponent } from './components/search-input-compact/search-input-compact.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { SearchSelectInputComponent } from './components/search-select-input/search-select-input.component';
import { SectionsComponent } from './components/sections/sections.component';
import { SecurityAlertComponent } from './components/security-alert/security-alert.component';
import { ServerErrorComponent } from './components/server-error/server-error.component';
import { SessionTimeOutComponent } from './components/session-time-out/session-time-out.component';
import { SquareIconComponent } from './components/square-icon/square-icon.component';
import { StatusIconComponent } from './components/status-icon/status-icon.component';
import { TimePickerComponent } from './components/time-picker/time-picker.component';
import { TimeComponent } from './components/time/time.component';
import { TreatedIconComponent } from './components/treated-icon/treated-icon.component';
import { ProcedureFormPreviewComponent } from './components/form-preview/procedure-form-preview/procedure-form-preview.component';
import { HelpSystemComponent } from './components/help-system/help-system.component';
import { ExpandableTooltipDirective } from './directives/expandable-tooltip.directive';
import { PreventMulticlickDirective } from './directives/prevent-multiclick.directive';
import { TodayTimeOrDateTimeCustomDatePipe } from './pipes/today-time-or-datetime';
import { DisableTemporaryDirective } from './directives/disable-temporary.directive';
import { FormEngineComponent } from './components/form-engine/form-engine.component';

const appearance: MatFormFieldDefaultOptions = {
	appearance: 'outline',
	//appearance: 'standard',
};

@NgModule({
	declarations: [
		GalleryComponent,
		EllipseComponent,
		SearchInputComponent,
		SquareIconComponent,
		FilterListComponent,
		NestedListsComponent,
		SectionsComponent,
		AuditComponent,
		SafePipe,
		SecondMenuComponent,
		EllipseLinkComponent,
		WarningMessageComponent,
		WarningNoteComponent,
		EditLabelComponent,
		IconCircleComponent,
		LetterAvatarComponent,
		StatusIconComponent,
		StatusLabelComponent,
		ConfirmComponent,
		FileDnDDirective,
		ChipComponent,
		PageSearchBarComponent,
		PageEditTitleComponent,
		DropZoneComponent,
		PageEmptySearchResultComponent,
		PageDisabledFeatureComponent,
		PageDialogComponent,
		StepperComponent,
		BreadcrumbComponent,
		MatQuill,
		AddLinkComponent,
		HelpSidenavComponent,
		PageWithTwoSidenavComponent,
		SessionTimeOutComponent,
		SecurityAlertComponent,
		ServerErrorComponent,
		PageScrollContentComponent,
		TimeComponent,
		HelpLabelComponent,
		HelpSystemComponent,
		SearchSelectInputComponent,
		PreventMulticlickDirective,
		CatalogDetailDialogComponent,
		IconSquareComponent,
		ExpandableInfoComponent,
		ExpandableTooltipDirective,
		ExpandableInfoOverlayComponent,
		DocumentLinkComponent,
		CatalogDetailProcedureTreeComponent,
		EditLabelAdvComponent,
		EditSelectLabelComponent,
		CopyClipboardComponent,
		SearchInputAdvComponent,
		TodayTimeOrDateTimeCustomDatePipe,
		CatalogRequestAccessDialogComponent,
		SearchInputCompactComponent,
		TimePickerComponent,
		TreatedIconComponent,
		ProcedureFormPreviewComponent,
		DisableTemporaryDirective,
		FormEngineComponent,
	],
	imports: [
		CommonModule,
		RouterModule,
		VendorModule,
		MatNativeDateModule,
		QuillModule.forRoot(),
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	exports: [
		VendorModule,
		FilterListComponent,
		EllipseComponent,
		NestedListsComponent,
		SearchInputComponent,
		SectionsComponent,
		SquareIconComponent,
		AuditComponent,
		EllipseComponent,
		SafePipe,
		TodayTimeOrDateTimeCustomDatePipe,
		SecondMenuComponent,
		EllipseLinkComponent,
		WarningMessageComponent,
		WarningNoteComponent,
		EditLabelComponent,
		IconCircleComponent,
		LetterAvatarComponent,
		StatusIconComponent,
		StatusLabelComponent,
		ConfirmComponent,
		FileDnDDirective,
		PageSearchBarComponent,
		PageEditTitleComponent,
		DropZoneComponent,
		PageEmptySearchResultComponent,
		PageDisabledFeatureComponent,
		PageDialogComponent,
		ChipComponent,
		StepperComponent,
		BreadcrumbComponent,
		QuillModule,
		MatQuill,
		HelpSidenavComponent,
		PageWithTwoSidenavComponent,
		PageScrollContentComponent,
		TimeComponent,
		HelpLabelComponent,
		HelpSystemComponent,
		SearchSelectInputComponent,
		PreventMulticlickDirective,
		IconSquareComponent,
		ExpandableInfoComponent,
		ExpandableTooltipDirective,
		DocumentLinkComponent,
		CatalogDetailProcedureTreeComponent,
		EditLabelAdvComponent,
		EditSelectLabelComponent,
		CopyClipboardComponent,
		SearchInputAdvComponent,
		SearchInputCompactComponent,
		TimePickerComponent,
		TreatedIconComponent,
		DisableTemporaryDirective,
		FormEngineComponent
	],
	providers: [{
		provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
		useValue: appearance,
	},
		DatePipe]
})
export class CommonSharedModule { }
